import { useState, useEffect, useCallback } from 'react';
import api from '../api';

export const useNotifiche = () => {
  const [badge, setBadge] = useState({ best_product: 0, aggiornamenti: 0, annunci: 0, totale: 0 });
  const [notifiche, setNotifiche] = useState([]);
  const [nonLette, setNonLette] = useState(0);

  const fetchBadge = useCallback(() => {
    api.get('/notifiche/badge').then(r => setBadge(r.data)).catch(() => {});
  }, []);

  const fetchNotifiche = useCallback(() => {
    api.get('/notifiche').then(r => {
      setNotifiche(r.data.notifiche || []);
      setNonLette(r.data.non_lette || 0);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    fetchBadge();
    fetchNotifiche();
    const interval = setInterval(() => {
      fetchBadge();
      fetchNotifiche();
    }, 60000);
    return () => clearInterval(interval);
  }, [fetchBadge, fetchNotifiche]);

  const segnaVista = useCallback((sezione) => {
    api.post(`/notifiche/segna-vista/${sezione}`).then(() => fetchBadge()).catch(() => {});
  }, [fetchBadge]);

  const segnaLetta = useCallback((id) => {
    api.post(`/notifiche/${id}/letta`).then(() => {
      fetchNotifiche();
      fetchBadge();
    }).catch(() => {});
  }, [fetchNotifiche, fetchBadge]);

  const leggiTutte = useCallback(() => {
    api.post('/notifiche/leggi-tutte').then(() => {
      fetchNotifiche();
      fetchBadge();
    }).catch(() => {});
  }, [fetchNotifiche, fetchBadge]);

  return { badge, notifiche, nonLette, segnaVista, segnaLetta, leggiTutte, refresh: fetchBadge };
};
